import { Link } from "react-router-dom";
import BgImage from './assets/img/bg/bg-banner-1.jpg';
function HeaderHero(props) {
    return (
        <section className="bg-primary effect-section section" style={{ backgroundImage: `url(${BgImage})` }}>
            <div className="mask bg-primary bg-opacity-80"></div>
            <div className="header-height-bar" style={{ minHeight: '76.7625px' }}></div>
            <div className="container position-relative">
                <div className="row justify-content-center">
                    <div className="col-lg-8 text-center">
                        <h2 className="text-white h1 mb-4">{props.Name}</h2>
                        <ol className="breadcrumb breadcrumb-light justify-content-center">
                            <li className="breadcrumb-item">
                                <Link to='/' >Home / </Link>
                            </li>
                            <li className="breadcrumb-item active">{props.Name}</li>
                        </ol>
                    </div>
                </div>
            </div>
        </section>
    );
}
export default HeaderHero;